import { associationIdName, countryStrings, fetchGet, noPictureUrl, levelsOfTargetsStrings } from "./common";
import { writable } from 'svelte/store';
import * as t from '../translations/Common.ts';
import type { Address } from "./address.ts";

export const directoryStore = writable<MatchedOfficials>({
    key: '',
    address: {},
    targetedMessages: [],
    matchedTargets: [],
    categories: [],
    selectedCategory: undefined
});

export interface MatchedOfficials {
    key: string,
    address: Address,
    targetedMessages: TargetedMessage[]
    matchedTargets: MatchedTarget[]
    categories: Category[],
    selectedCategory?: Category
}

export interface TargetedMessage {
    availableDeliveryMethods: string[]
    id: number
    messageDisplay: any
    messages: Message[]
    phoneCallMethod: any
    preSelectedAnswers: any
    targets: Target[]
}

export interface Message {
    guidelines: any
    message: any
    phoneGuidelines: any
    readOnly: boolean
    sampleMessageId: any
    shortenedGuidelines: any
    showOpeningAndClosing: boolean
    subject: any
}

export interface PoliticianScore {
    politicianId: number
    score: number
}

export interface Target {
    displayCategory: string
    displayName: string
    groupId: string
}

export interface Category {
    referenceName: string
    countries: string[]
    name: string
    description: string
    profiles?: Profile[]
}

export interface MatchedTarget {
    groupId: string
    matches: Match[]
    messageId: number
}

export interface Match {
    addressIdentities: string[]
    id: number
    name: string
    type: string
}

export interface Profile {
    displayName: string
    id: string
    personName: PersonName
    photoUrl: string
    sections: Section[],
    party?: string,
    state?: string,
    titleAndName?: string
}

export interface PersonName {
    familiarName: string
    givenNames: string
    suffix?: string
    surname: string
    title: string
}

export interface Section {
    category: string
    name: string
    properties: Property[]
}

export interface Property {
    description: any
    name: string
    value: string
}

export interface PoliticianIdentifier {
    id: number;
    type: string;
}

export interface MessageDeliveryOption {
  constituentOnly: boolean
  deliveryMethod: string
  maximumSubjectLength?: number
  maximumMessageLength?: number
  requiredQuestions?: RequiredQuestion[]
  requiredUserFields: string[]
  sharedQuestionIds?: string[]
}

export interface RequiredQuestion {
  question: string
  validAnswers: string[]
}


export const possibleCategories: Category[] = [
    {
        referenceName: levelsOfTargetsStrings.federal,
        countries: [countryStrings.us],
        name: t.Federal_Label(),
        description: t.US_Federal_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.federal,
        countries: [countryStrings.ca],
        name: t.Federal_Label(),
        description: t.CA_Federal_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.state,
        name: t.US_State_Label(),
        countries: [countryStrings.us],
        description: t.US_State_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.state,
        name: t.CA_State_Label(),
        countries: [countryStrings.ca],
        description: t.CA_State_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.local,
        name: t.Local_Label(),
        countries: [countryStrings.us],
        description: t.US_Local_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.local,
        name: t.Local_Label(),
        countries: [countryStrings.ca],
        description: t.CA_Local_Description(),
        profiles: []
    },
    {
        referenceName: levelsOfTargetsStrings.media,
        name: t.Media_Label(),
        countries: [countryStrings.us, countryStrings.ca],
        description: t.Media_Description(),
        profiles: []
    }
]

export const getTargetedMessages = async () => {
    const url = `Advocacy/TargetedMessages?association=${associationIdName}`;
    const response = await fetchGet(url) as TargetedMessage[];
    return response;
}

export const getMatchedTargets = async (address: Address) => {
    const encodedAddress = encodeURIComponent(JSON.stringify(address));
    const url = `Advocacy/MatchedTargets?association=${associationIdName}&home=${encodedAddress}`;
    const response = await fetchGet(url) as MatchedTarget[];
    return response;
}

export const getMessageDeliveryOptions = async (targetType: string, targetId: number) => {
    const url = `Advocacy/MessageDeliveryOptions?association=${associationIdName}&targetType=${targetType}&targetId=${targetId}`;
    const response = await fetchGet(url) as MessageDeliveryOption[];
    return response;
}

export function onProfileImageError(e: any) {
    e.currentTarget.src = noPictureUrl;
}